import { ReactNode } from "react";
import { Folder, Folders, GraduationCap } from "lucide-react";
import { CatalogEntityType } from "./types";

export const ENTITY_ICON: Record<CatalogEntityType, ReactNode> = {
  activity: <GraduationCap size={20} />,
  course: <Folder size={20} />,
  path: <Folders size={20} />,
};
